import Vue          from 'vue'

Vue.component('s-cabecalho',            () => import('./cabecalho.vue'));
Vue.component('s-rodape',               () => import('./rodape.vue'));

Vue.component('s-sobre',                () => import('./sobre.vue'));
Vue.component('s-areas-de-atuacao',     () => import('./areas-de-atuacao.vue'));
Vue.component('s-portfolio',            () => import('./portfolio.vue'));
Vue.component('s-equipe',               () => import('./equipe.vue'));
Vue.component('s-artigos',              () => import('./artigos.vue'));